<template>
    <!-- 报告 -->
    <div style="background: #F4F7FA;position: relative;">
        <div class="card" id="char" ref="char">
            <div class="report">
                <div class="report-header">
                    <h1>FOF/MOM尽调信息表</h1>
                    <img src="../../assets/images/report_top.png" alt="">
                </div>
                <ul class="report-card">
                    <li>
                        <span class="label">尽调报告人</span>
                        <span class="tag">研究员</span>
                        <span style="margin: 0 90px 0 35px;">张三</span>
                        <span class="tag">风控</span>
                        <span style="margin-left: 35px;">秦XX</span>
                    </li>
                    <li>
                        <span class="label">尽 调 时 间</span>
                        <span>2023年5月23日</span>
                    </li>
                    <li>
                        <span class="label">尽 调 方 式</span>
                        <span>线上</span>
                    </li>
                    <li>
                        <span class="label">尽 调 策 略</span>
                        <span>量化策略</span>
                    </li>
                    <li>
                        <span class="label">管理人名称</span>
                        <span>上海XXXX资产管理有限公司</span>
                    </li>
                    <li>
                        <span class="label">接 待 人 员</span>
                        <span class="tag">姓名</span>
                        <span style="margin: 0 25px 0 10px;">张老三</span>
                        <span class="tag">职务</span>
                        <span style="margin: 0 25px 0 10px;">基金经理</span>
                        <span class="tag">联系方式</span>
                        <span style="margin-left: 10px;">152****6952</span>
                    </li>
                    <li>
                        <span class="label">名 片</span>
                        <img src="../../assets/images/upload.png" alt="">
                        <span style="margin-left: 12px;color: #00567E;">名片上传</span>
                    </li>
                </ul>
                <div class="report-table mt30">
                    <div class="report-table-col br">管理人<br>基本信息</div>
                    <!-- 右侧 -->
                    <ul class="report-table-cor">
                        <li>
                            <span>成立时间</span>
                            <span style="width: 187px;">2017年5月</span>
                            <span>登记时间</span>
                            <span>2019年8月</span>
                        </li>
                        <li>
                            <span>注册资本</span>
                            <span style="width: 187px;">1000 万</span>
                            <span>实缴资本</span>
                            <span>900 万</span>
                        </li>
                        <li>
                            <span>注册地点</span>
                            <span style="width: 187px;">浙江宁波</span>
                            <span>办公地点</span>
                            <span>北京、上海、香港</span>
                        </li>
                        <li>
                            <span>总规模</span>
                            <span style="width: 187px;">60 亿</span>
                            <span style="width: 230px;">规模（金方数据库）</span>
                            <span>50 亿</span>
                        </li>
                        <li>
                            <span>产品数量</span>
                            <span style="width: 187px;">100 只</span>
                            <span style="width: 230px;">数量（金方数据库）</span>
                            <span>120 只</span>
                        </li>
                        <li>
                            <div class="special"><div class="center">资金来源</div></div>
                            <pre class="preCon" style="width: 528px;">{{ managerInfo.zjly }}</pre>
                        </li>
                        <li>
                            <div class="special pl0" style="justify-content: center;"><div>主策略及规模</div></div>
                            <ul>
                                <li>
                                    <span class="yColor">量化策略</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor">中性策略</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor">CTA策略</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor">套利策略</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <pre class="preCon" style="width: 528px;">{{ managerInfo.zclgm }}</pre>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <div class="special pl0" style="justify-content: center;"><div>产品线及规模</div></div>
                            <ul>
                                <li>
                                    <span class="yColor">500指增</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor">CTA趋势</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor">商品套利</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor" style="width: 185px;">股票中性产品</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <span class="yColor" style="width: 185px;">多策略产品</span>
                                    <span>20 亿</span>
                                </li>
                                <li>
                                    <pre class="preCon" style="width: 528px;">{{ managerInfo.cpxgm }}</pre>
                                </li>
                                <li class="yColor br0"><p>策略代表产品xx</p></li>
                                <li><pre class="preCon" style="width: 528px;"></pre></li>
                            </ul>
                        </li>
                        <li><p class="bColor">公司员工</p></li>
                        <li>
                            <span class="yColor" style="width: 165px;">员工总人数</span>
                            <span style="width: 164px;">26 人</span>
                            <span class="yColor" style="width: 182px;">核心投研人员</span>
                            <span>18 人</span>
                        </li>
                        <li>
                            <span class="yColor" style="width: 142px;">核心高管</span>
                            <span style="width: 187px;">26 人</span>
                            <span class="yColor" style="width: 142px;">基金经理</span>
                            <span>18 人</span>
                        </li>
                        <li>
                            <span class="yColor" style="width: 142px;">研究员</span>
                            <span style="width: 187px;">26 人</span>
                            <span class="yColor" style="width: 142px;">IT</span>
                            <span>18 人</span>
                        </li>
                        <li>
                            <span class="yColor" style="width: 142px;">交易员</span>
                            <span style="width: 187px;">26 人</span>
                            <span class="yColor" style="width: 142px;">风控</span>
                            <span>18 人</span>
                        </li>
                        <li>
                            <span class="yColor" style="width: 142px;">市场</span>
                            <span style="width: 187px;">26 人</span>
                            <span class="yColor" style="width: 142px;">其他</span>
                            <span>18 人</span>
                        </li>
                        <li>
                           <pre class="preCon">{{ managerInfo.gsyg }}</pre> 
                        </li>
                        <li><p class="bColor">核心投研人员简历</p></li>
                        <li>
                            <pre class="preCon">{{ managerInfo.ryjl }}</pre>
                        </li>
                        <li><p class="bColor">IT硬件投入（量化策略）</p></li>
                        <li>
                            <span class="yColor" style="width: 160px;">已累计投入</span>
                            <span style="width: 169px;">1 亿</span>
                            <span class="yColor" style="width: 167px;">每年预算投入</span>
                            <span>1000 万</span>
                        </li>
                        <li><pre class="preCon">{{ managerInfo.yjtr }}</pre></li>
                        <li><p class="bColor">公司股权情况</p></li>
                        <li>
                            <span class="yColor" style="width: 160px;">郭某某</span>
                            <span style="width: 169px;">75 %</span>
                        </li>
                        <li>
                            <span class="yColor" style="width: 323px;">山西XX合伙企业</span>
                            <span>25 %</span>
                        </li>
                        <li><pre class="preCon">{{ managerInfo.gqqg }}</pre></li>
                        <li><p class="bColor">其他信息</p></li>
                        <li><pre class="preCon">{{ managerInfo.qtxx }}</pre></li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 下载 -->
        <div class="upload" @click="saveImage('char', 'FOF/MOM尽调信息表');"><i class="el-icon-bottom"></i></div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
export default {
    name: "report",
    data() {
        return {
            reportType: '',
            managerInfo: {
                zjly: '70%为机构资金，自有资金比例30%，中信银行、瑞银证券代销40亿，机构直投4亿，其余客户直销',
                zclgm: '按介绍，公司2014年成立，最早的策略是股指超高频策略，年换手率几百倍；2016年之后，高频策略主要应用于商品策略端；2018、2019年开始开发股票、期权等策略',
                cpxgm: '代表产品寰宇一号，成立日期2017-11-10，规模2-3亿。成立至今年化收益8.5%，最大回撤5.7%；年初至今收益-2.03%。按介绍，去年5月份后中长周期策略上线，业绩贡献上看，去年下半年主要是中短周期策略盈利，年底阶段中短周期、中长周期策略均逐步盈利。',
                gsyg: '团队的总人数大概是80人，投研大概是59人，海外常青藤和国内的清北毕业为主。策略团队也有一些从海外Citedel,2sigma归国的，技术团队也有着美国头部互联网公司回来的一些系统工程师。',
                ryjl: '杨树彬 投资总监毕业于复旦大学经济学院金融系，后就读于卡耐基梅隆大学计算金融专业，于2013年12月获得理学硕士学位。 毕业后于2014年2月就职于芝加哥 HTG Capital Partners 公司，从事针对美国股指期货的程序化交易的策略研究工作。2015年1月加入上海量游资产管理有限公司，从事国内市场的算法交易策略的开发与基金管理等工作。2017年7月升任资深投资经理与合伙人。目前担任量游1号，量游2号，量游3号等产品的基金经理。投资风格以追求高收益风险比的稳健型绝对收益策略为主，投资标的包括股票，商品期货，股指期货等',
                yjtr: '公司秉持投研加IT双轮驱动模式。低延时交易系统在最近两年里面，纯硬件上的投入都是大几千万。2022年的硬件上的投入1.1亿，2021年8000万。在北京大兴，有2000平方米的机房；在券商的机房托管服务器超过150台',
                gqqg: '创始人郭毅并不直接持股，而是其家人持股70%，主要是因为公司成立之初时一些监管政策上的限制，所以没有直接持股；另外30%为一家山西合伙企业，由上海一家企业控股，主要是公司一期员工、基金经理持股、员工激励计划。',
                qtxx: '公司成立之后主要做商品套利，当时简单套利策略年化收益能轻松做到20%以上，但之后收益衰减，公司转型做alpha策略，并走阳光化私募道路，于2014年3月获得管理人牌照，2015年3月，登记成为中国证券基金业的会员。公司转型并未获得成功，alpha策略的核心经理被挖走，但在16年-20年期间拓宽了机构渠道，依旧留下宝贵资源。2020年公司再度切换赛道，深耕期权方向。公司认为大的赛道会极度拥挤，内卷严重，另类策略和小众资产表现可能会更好。',
            }
        }
    },
    mounted() {
        this.reportType = this.$route.query.type
        console.log(this.reportType);
    },
    methods: {
        //图片转换格式
        dataURLToBlob(dataurl) {
            let arr = dataurl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
        //保存图片的方法，id名 图片名称
        saveImage(divText, imgText) {
            let canvasID = this.$refs[divText];
            let that = this;
            let a = document.createElement('a');
            html2canvas(canvasID).then(canvas => {
                let dom = document.body.appendChild(canvas);
                dom.style.display = 'none';
                a.style.display = 'none';
                document.body.removeChild(dom);
                let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
                a.setAttribute('href', URL.createObjectURL(blob));
                //这块是保存图片操作  可以设置保存的图片的信息
                a.setAttribute('download', imgText + '.png');
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(blob);
                document.body.removeChild(a);
            });
        },
    }
}
</script>

<style lang="less" scoped>
.card {
    margin: 0 auto;
    padding: 70px;
    box-sizing: border-box;
    width: 1200px;
    background: @whiteColor;
    .report {
        margin: 0 auto;width: 100%;border: 3px solid @mainColor;padding-bottom: 80px;color:@color3;
        &-header {
            margin-bottom: 45px;height: 70px;display: flex;justify-content: space-between;line-height: 63px;
            h1 {margin: 18px 0 0 114px;color: @mainColor;font-size: 36px;}
        }
        &-card {
            box-sizing: border-box;padding: 25px 18px;margin: 0 auto;width: 835px;background: @reportBgColor;border-radius: 15px;font-size: 20px;
            li {
                display: flex;align-items: center; padding: 0 21px;height: 63px;
                .label {width: 110px;text-align-last: justify;margin-right: 45px;}
                .tag {padding: 8px 16px;background: @oColor7;border-radius: 8px;color: @mainColor;}
            }
            li:nth-child(2n+1) {
                height: 58px;background: @whiteColor;border-radius: 8px;opacity: 0.8;
            }
        }
        &-table {
            margin: 0 auto;width: 835px;border: 1px solid @oColor8;font-size:20px;display: flex;
            &-col {
                background: @reportBgColor;padding-top: 166px;text-align: center;width: 165px;box-sizing:border-box;border-right: 1px solid @oColor8;line-height: 36px;
            }
            &-cor {
                width:670px;
                li{
                    display: flex;border-bottom: 1px solid @oColor8;
                    span {padding: 18px 0;box-sizing: border-box;}
                    span:nth-child(2n) {padding-left: 20px;}
                    span:nth-child(2n+1), .special {width: 142px;background: @reportBgColor;padding-left: 30px;border-right: 1px solid @oColor8;} 
                    span:nth-child(3) {border-left: 1px solid @oColor8;}
                    p {padding: 18px;width: 100%;text-align: center;}
                    .pl0 {padding-left: 0!important;text-align: center;}
                    .special {box-sizing: border-box;display: flex;align-items: center;} 
                }
                li:last-child {border-bottom: 0;}
            }
            .preCon {box-sizing: border-box;max-width: 670px;white-space: pre-wrap;padding: 20px 28px;line-height: 32px;text-align: justify;}
            .yColor {background: @oColor9!important;border-right: 1px solid @oColor8;}
            .bColor {background: @reportBgColor!important;}
            .br0 {border-right: 0;}
        }
    }
}
.upload {
    position: fixed;
    background-color: @whiteColor;
    width: 40px;
    height: 40px;
    right: 50px;
    top: 100px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 0 9px #91b6d6;
    cursor: pointer;
    color: @mainColorZb;
}
</style>